/**
 * A face, or the next best thing.
 *
 * The photo booth (§6) does not exist yet, so `avatarUrl` is null for
 * everybody. A monogram is not a placeholder for a missing avatar — it is what
 * these rows show until there are photographs, and it still tells you who.
 *
 * Shared by the hype meter and the termin rail's "who is coming" row, which
 * are two lists of the same kind of thing: hype is who fancies the film, the
 * other is who has actually taken a seat.
 */
export function Face({
  nickname,
  avatarUrl,
  className = 'hype__face',
}: {
  nickname: string;
  avatarUrl: string | null;
  className?: string;
}) {
  return (
    <span className={className} title={nickname}>
      {avatarUrl ? (
        <img src={avatarUrl} alt={nickname} loading="lazy" decoding="async" />
      ) : (
        <span aria-hidden="true">{[...nickname][0]?.toUpperCase() ?? '?'}</span>
      )}
      <span className="sr-only">{nickname}</span>
    </span>
  );
}
